import Iaphub from './iaphub';

export default new Iaphub();